<template>
  <form
    class="FormGetStarted main-started-form"
    :class="{ 'is--hidden-input': isLoggedIn }"
    novalidate
  >
    <BaseFormInput
      v-model="email"
      class="input main-started-form__input"
      type="email"
      placeholder="Email Address"
    />
    <BaseButton
      type="submit"
      class="main-started-form__button"
      color="primary"
      large
      @click.prevent="onSubmit"
    >
      Get Started
    </BaseButton>
  </form>
</template>

<script lang="ts">
import { triggerGetStarted } from '@/analytics';
import { defineComponent, ref } from 'vue';
import { BaseButton } from 'Components/Base/BaseButton';
import BaseFormInput from 'Components/Base/BaseFormInput.vue';

export default defineComponent({
  components: {
    BaseButton,
    BaseFormInput,
  },
  props: {
    isLoggedIn: Boolean,
  },
  setup(props) {
    const email = ref('');

    function onSubmit() {
      triggerGetStarted(email.value);
      if (props.isLoggedIn) window.location.replace('/investments/primary-offerings');
      else window.location.replace(`/sign-up?email=${email.value}`);
    }

    return {
      email,
      onSubmit,
    };
  },
});
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.main-started-form
  display: flex
  flex-direction: row
  width: 100%
  height: 48px
  @media screen and (max-width: 575px)
    margin: auto
  &__input
    width: 100%
    @media screen and (max-width: 767px)
      margin-left: 0
      display: none
    @media screen and (max-width: 425px)
      padding: 0 15px
    &:focus
      border-color: $mercury
  &__button
    margin-left: 10px
    width: 161px
    flex-shrink: 0
    @media screen and (max-width: 767px)
      min-width: 160px
      margin-left: 0
  &.is--hidden-input
    box-shadow: none
    .main-started-form__button
      margin-left: 0
    .input
      display: none
</style>
